"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CanvasDimensions = void 0;
const rc_js_util_1 = require("rc-js-util");
const full_clip_space_range2d_1 = require("../transforms/full-clip-space-range2d");
const full_clip_space_size2d_1 = require("../transforms/full-clip-space-size2d");
const reverse_y_full_clip_space_range2d_1 = require("../transforms/reverse-y-full-clip-space-range2d");
const canvas_transforms_1 = require("./canvas-transforms");
/**
 * @public
 * {@inheritDoc ICanvasDimensions}
 */
class CanvasDimensions {
    constructor(dpr, cssDims, pixelDims, boundingRect) {
        this.dpr = dpr;
        this.cssDims = cssDims;
        this.pixelDims = pixelDims;
        this.boundingRect = boundingRect;
        this.transforms = new canvas_transforms_1.CanvasTransforms(full_clip_space_range2d_1.fullClipSpaceRange2d.getRangeTransform(pixelDims), full_clip_space_range2d_1.fullClipSpaceRange2d.getRangeTransform(cssDims), pixelDims.getRangeTransform(full_clip_space_range2d_1.fullClipSpaceRange2d), cssDims.getRangeTransform(full_clip_space_range2d_1.fullClipSpaceRange2d));
        this.reverseYTransforms = new canvas_transforms_1.CanvasTransforms(reverse_y_full_clip_space_range2d_1.reverseYFullClipSpaceRange2d.getRangeTransform(pixelDims), reverse_y_full_clip_space_range2d_1.reverseYFullClipSpaceRange2d.getRangeTransform(cssDims), pixelDims.getRangeTransform(reverse_y_full_clip_space_range2d_1.reverseYFullClipSpaceRange2d), cssDims.getRangeTransform(reverse_y_full_clip_space_range2d_1.reverseYFullClipSpaceRange2d));
        this.pixelToClipSize = pixelDims.getRangeTransform(full_clip_space_size2d_1.fullClipSpaceSize2d);
    }
    updateBoundingRects(boundingRect) {
        this.boundingRect.update(boundingRect.left, boundingRect.right, boundingRect.top, boundingRect.bottom);
    }
    static createDefault() {
        return new CanvasDimensions(1, rc_js_util_1.Range2d.f32.factory.createOne(0, 300, 0, 300), rc_js_util_1.Range2d.f32.factory.createOne(0, 300, 0, 300), rc_js_util_1.Range2d.f32.factory.createOne(0, 300, 0, 300));
    }
    clone() {
        return new CanvasDimensions(this.dpr, this.pixelDims, this.pixelDims, this.boundingRect);
    }
}
exports.CanvasDimensions = CanvasDimensions;
//# sourceMappingURL=canvas-dimensions.js.map